import type { WindowMulticastSubscription } from "./types.js";

/**
 * True when `subscription` delivers packets in batches through the `packets`
 * provider extension (BLO-36599).
 *
 * The pim window-multicast-bridge (0.2.0 and later) advertises the extension
 * in `eventTypes`. It builds only the events some listener asked for, so a
 * consumer that listens to `packets` alone gets one event per reader batch
 * instead of one DOM event per packet. A provider without the field, or one
 * that does not list `packets`, is a v1 provider: listen to `bytes`.
 */
export function subscriptionDeliversPacketBatches(
	subscription: Pick<WindowMulticastSubscription, "eventTypes">,
): boolean {
	return subscription.eventTypes?.includes("packets") === true;
}
